const coordinates = [
  [92.73598262, 11.66702557], //AND
  [78.57002559, 14.7504291], //AP
  [93.61660071, 27.10039878], //AARUNA
  [94.21666744, 26.7499809], //ASSA
  [87.4799727, 25.78541445], //BIHAR
  [76.78000565, 30.71999697], //CHANDIGARH
  [82.15998734, 22.09042035], //CHATTISGEARH
  [77.23000403, 28.6699929], //DELHI
  [73.0166178, 20.26657819], //DADRA AND NAGAR
  [73.81800065, 15.491997], //GOA
  [72.13623, 22.309425], //GUJARAT
  [77.16659704, 31.10002545], //HIMACHAL
  [77.01999101, 28.45000633], //HARYANA
  [86.41998572, 23.80039349], //JHARKHAND
  [74.46665849, 34.29995933], //J&K
  [76.91999711, 12.57038129], //KARNATAKA
  [76.56999263, 8.900372741], //KERALA
  [77.615112, 34.209515], //LADAKH
  [72.63686717, 10.56257331], //laskhadweep
  [73.16017493, 19.25023195], //MAHA
  [91.8800142, 25.57049217], //MEGHALA
  [93.95001705, 24.79997072], //MANIPUR
  [77.947998, 23.473324], //MADHYA PR
  [92.72001461, 23.71039899], //MIZORAN
  [94.11657019, 25.6669979], //NAGALND
  [85.90001746, 19.82042971], //ODISHA
  [75.98000281, 31.51997398], //PUNJ
  [79.83000037, 11.93499371], //PUDU
  [74.63998124, 26.44999921], //RAJ
  [88.6166475, 27.3333303], //SIKKIM
  [79.208824, 17.123184], //TELANDGA
  [79.15004187, 12.92038576], //TN
  [91.27999914, 23.83540428], //TRIPUR
  [0, 0],
  [78.05000565, 27.59998069], //UP
  [78.05000565, 30.32040895], //UTTARAKHAND
  [88.32994665, 22.58039044], //WB
];

exports.coordinates = coordinates;
